import { NgModule } from "@angular/core";
import { AuthGuard } from "./main/auth/auth.guard";
import { P404Component } from "./main/error/404.component";
import { P500Component } from "./main/error/500.component";
import { LoginComponent } from "./main/login/login.component";
import { ResetPasswordComponent } from "./main/reset-password/reset-password.component";
import { ChangePasswordComponent } from "./main/change-password/change-password.component";
import { RouterModule, Routes } from "@angular/router";
import { DefaultLayoutComponent } from "./containers";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "404",
    component: P404Component,
    data: {
      title: "Page 404",
    },
  },
  {
    path: "500",
    component: P500Component,
    data: {
      title: "Page 500",
    },
  },
  {
    path: "login",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: "forgot-password",
    component: ResetPasswordComponent,
    data: {
      title: "Forgot Pasword",
    },
  },
  {
    path: "reset-password",
    component: ChangePasswordComponent,
    data: {
      title: "Reset Password",
    },
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    data: {
      title: "Home",
    },
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./main/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "earnings",
        loadChildren: () =>
          import("./main/earnings/earnings.module").then(
            (m) => m.EarningsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "report",
        loadChildren: () =>
          import("./main/report/report.module").then((m) => m.ReportModule),
        canActivate: [AuthGuard],
      },
      {
        path: "document",
        loadChildren: () =>
          import("./main/document/document.module").then(
            (m) => m.DocumentModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "passage-report",
        loadChildren: () =>
          import("./main/passage-report/passage-report.module").then(
            (m) => m.PassageReportModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "ship-docs",
        loadChildren: () =>
          import("./main/ship-docs/ship-docs.module").then(
            (m) => m.ShipDocsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "help-support",
        loadChildren: () =>
          import("./main/help-support/help-support.module").then(
            (m) => m.HelpSupportModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "setting",
        loadChildren: () =>
          import("./main/setting/setting.module").then((m) => m.SettingModule),
        canActivate: [AuthGuard],
      },
      {
        path: "research",
        loadChildren: () =>
          import("./main/research/research.module").then(
            (m) => m.ResearchModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "market",
        loadChildren: () =>
          import("./main/market-updates/market-updates.module").then(
            (m) => m.MarketUpdatesModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "workshops",
        loadChildren: () =>
          import("./main/workshop/workshop.module").then(
            (m) => m.WorkshopModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "monthly-operation-circulars",
        loadChildren: () =>
          import(
            "./main/monthly-operation-circulars/monthly-operation-circulars.module"
          ).then((m) => m.MonthlyOperationCircularModule),
      },
      {
        path: "vessel-tracking",
        loadChildren: () =>
          import("./main/vessel-tracking/vessel-tracking.module").then(
            (m) => m.VesselTrackingModule
          ),
      },
    ],
  },
  { path: "**", component: P404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
